import { useLocation } from 'react-router-dom';
import NavBar from '../common/Navbar/NavBar';
import Footer from '../vievs/Footer/Footer';
import Header from '../vievs/Header/Header';
import styles from '../layout/layout.module.scss';

const Layout = ({ children }) => {
  const { pathname } = useLocation();

  // hide header:
  const showHeader = pathname === '/';
  // location.pathname !== '/offers' && location.pathname !== '/aboutUs';
  return (
    <div className={styles.appLayout}>
      <NavBar />
      {showHeader && <Header />} {/* show only with  "/" */}
      <main className={styles.mainContent}>{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;
